import React from 'react'
import './styles.css'

type Props = {

}

export const Footer: React.FC<Props> = () => {
  return (
    <footer>
      <div>
        <p>© 2026 Phrayz</p>
        <p>All rights reserved.</p>
        <p>
            Wilmington, NC
        </p>
      </div>

      <div>
        <a href="/about">About Us</a>
        <a href="/privacy">Privacy Policy</a>
        <a href="/terms">Terms of Service</a>
        <a href="mailto:hello@inbox.phrayz.com">Contact Us</a>
      </div>

      <div>
        <p>
            Connect with us
        </p>
        <a href="https://www.linkedin.com/company/phrayz">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#666" viewBox="0 0 256 256"><path d="M216,24H40A16,16,0,0,0,24,40V216a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V40A16,16,0,0,0,216,24Zm0,192H40V40H216V216ZM96,112v64a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0Zm88,28v36a8,8,0,0,1-16,0V140a20,20,0,0,0-40,0v36a8,8,0,0,1-16,0V112a8,8,0,0,1,15.79-1.78A36,36,0,0,1,184,140ZM100,84A12,12,0,1,1,88,72,12,12,0,0,1,100,84Z"></path></svg>
        </a>
        <a
          href="https://www.producthunt.com/products/phrayz/reviews?utm_source=badge-product_review&utm_medium=badge&utm_souce=badge-phrayz"
          target="_blank"
        >
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/product_review.svg?product_id=641686&theme=light"
            alt="Phrayz - Create&#0032;Expert&#0045;Like&#0032;Content&#0032;In&#0032;No&#0032;Time | Product Hunt"
            width={250}
            height={54}
          />
        </a>
      </div>
      <div>
        <a href="https://phrayz.com">
          <img src="/assets/logo.png" alt="Phrayz" height="50" />
        </a>
      </div>
    </footer>
  )
}

